export default "__VITE_ASSET__BjrPlJrp__"